import React from 'react';
import { Table, Header, Segment, Icon, Tab, Loader, Divider, Label } from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { ToastContainer, toast } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const formatCourses = (data) => data.reduce(
    (acc, val) => {
        // if (!val.mandatory) return acc;
        if (acc[val.semesterNumber]) {
            acc[val.semesterNumber] = [...acc[val.semesterNumber], val];
        } else {
            return { ...acc, [val.semesterNumber]: [val] };
        }
        return acc;
    },
    {}
);

export default class StudentCoursesOverview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            allCourses: [],
            showTable: null,
            currentSemester: null,
            loading: true,
            error: false,
        };
        this.fetchCourses = this.fetchCourses.bind(this);
        this.expandTable = this.expandTable.bind(this);
    }
    componentDidMount() {
        this.fetchCourses();
    }
    fetchCourses(sspid) {
        axios.get(`students/study-program/overview/${window.$locale || 'bs'}`)
            .then(res => {
                this.setState({
                    data: res.data,
                    allCourses: formatCourses(res.data),
                    loading: false
                });
            }).catch(err => {
                toast(<FormattedMessage id="common.error" />);
                this.setState({ error: true });
            });
        axios.get('students/study-program/current-semester')
            .then(res => {
                this.setState({
                    currentSemester: res.data.number
                });
            });
    }
    expandTable(semesterId) {
        // collapse if same
        if (this.state.showTable === semesterId) {
            // const filteredShowTable = this.state.showTable.filter(el => el !== semesterId);
            this.setState({ showTable: null });
        } else {
            this.setState({ showTable: semesterId });
        }
    }
    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>

                <Header as="h1"> <FormattedMessage id="student.studyProgramView" /></Header>
                <Segment.Group raised>
                    {Object.keys(this.state.allCourses).map(tableData =>
                        (
                            <SemesterTableSegmentGroup
                                data={this.state.allCourses[tableData].sort((a, b) =>
                                    (Number(b.mandatory) - Number(a.mandatory)) ||
                                    a.courseName.localeCompare(b.courseName, 'bs'))}
                                semesterNumber={tableData}
                                expandTable={this.expandTable}
                                showTable={this.state.showTable === tableData || this.state.currentSemester === parseInt(tableData)}
                                currentSemester={this.state.currentSemester }
                            />))}
                </Segment.Group>
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}


const SemesterTable = ({ data, currentSemester }) => (
    <div>
        {data.length ? <Table tablet stackable celled selectable compact >
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell colSpan={4}><FormattedMessage id="common.courseName" /></Table.HeaderCell>
                    <Table.HeaderCell><FormattedMessage id="common.courseCode" /></Table.HeaderCell>
                    <Table.HeaderCell width={1}><FormattedMessage id="common.ects" /></Table.HeaderCell>
                    <Table.HeaderCell ><FormattedMessage id="common.lectureExerciseSeminar" /></Table.HeaderCell>
                    <Table.HeaderCell width={2}><FormattedMessage id="common.courseType" /></Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {data.map(row => (
                    <Table.Row>
                        <Table.Cell verticalAlign="middle" colSpan={4}>{row.courseName}</Table.Cell>
                        <Table.Cell verticalAlign="middle">{row.courseCode}</Table.Cell>
                        <Table.Cell verticalAlign="middle" width={1}>{row.ects}</Table.Cell>
                        <Table.Cell verticalAlign="middle" >{row.lectureHours} + {row.exerciseHours} + {row.seminarHours ? row.seminarHours : '0'} </Table.Cell>
                        <Table.Cell verticalAlign="middle">{row.mandatory ? <FormattedMessage id="common.mandatory" /> : <FormattedMessage id="common.optional" />}</Table.Cell>
                    </Table.Row>
                ))}
            </Table.Body>
        </Table> : <FormattedMessage id="professorInputGrades.noCourses" />}</div>
);

const SemesterTableSegmentGroup = ({
    semesterNumber, data, expandTable, showTable, currentSemester
}) => (
    <Segment tertiary={showTable} style={parseInt(semesterNumber, 10) == currentSemester ? { backgroundColor: '#EDF6FC' } : {}} >
        {/* <Segment onClick={() => expandTable(semesterNumber)} style={{ cursor: 'pointer' }} > */}
        {/* <Header as="h3"> */}
        {/*    <FormattedMessage id="common.semester" /> {semesterNumber} */}
        {/*    {!currentSemester && <Header style={{ fontSize: '9px' }} floated="right"> */}
        {/*        <Icon /> */}
        {/*        <Icon link circular basic floated="right" name={showTable ? 'chevron up' : 'chevron down'} /> */}
        {/*    </Header>} */}
        {/* </Header> */}
        <Divider onClick={() => expandTable(semesterNumber)} style={{ cursor: 'pointer' }} horizontal>
            <Header as="h4" color={parseInt(semesterNumber, 10) == currentSemester ? 'blue' : ''}>

                {parseInt(semesterNumber, 10) == currentSemester && <span><Header as="h6"><FormattedMessage id="student.currentlyEnrolled" /></Header></span>}
                {showTable ? <div><FormattedMessage id="common.semester" /> {semesterNumber}</div> :
                    <Label as="a" basic size={'large'}>
                    <div><FormattedMessage id="common.semester" /> {semesterNumber}</div>
                </Label>
                }

            </Header>
        </Divider>
        {/* </Segment> */}
        {showTable && <SemesterTable data={data} currentSemester={currentSemester} />}
    </Segment>
);



// WEBPACK FOOTER //
// ./src/views/StudentCoursesOverview/StudentCoursesOverview.js